'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionsStatus', ['$scope', '$stateParams', 'IPStatuses', '$state', function ($scope, $stateParams, IPStatuses, $state) {
        $scope.status = $stateParams.status;
        $scope.statusID = $stateParams.id;
        $scope.saving = false;
        $scope.deleting = false;
        $scope.loading = false;
        
        if ($stateParams.id != null) {
            $scope.loading = true;

            IPStatuses.getByID($stateParams.id).then(function(status) {
                $scope.status = status;
                $scope.loading = false;
            });            
        }
        else {
            $scope.status = {};
            IPStatuses.get().then(function (statuses) {
                $scope.status.sort_order = Math.max.apply(Math, statuses.map(function (status) { return status.sort_order; })) + 1;
            });
        }

        $scope.save = function () {
            $scope.saving = true;

            IPStatuses.save($scope.status).then(function (status) {
                $state.go('internal.inspecting.resource.statuses');
                $scope.saving = false;
            })
        }

        $scope.delete = function () {
            $scope.deleting = true;

            IPStatuses.delete($scope.statusID).then(function () {
                $state.go('internal.inspecting.resource.statuses');
                $scope.deleting = false;
            })
        }
    }])
;